/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';

import { Box, Button, IconButton, Menu, MenuItem, Stack, Tab, Tabs, Typography } from '@mui/material';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';

import { ArtworkContext } from 'contexts/ArtworkContext';
import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { FileSelectorGrid } from 'components/shared/file-selector/FileSelectorGrid';
import { InfiniteScrollPagination } from 'components/common/InfiniteScrollPagination';

import { useArtworkFilesData } from 'hooks/useArtworkFilesData';

export const ArtworkFiles = (props) => {
  const { close } = props;
  const [activeTab, setActiveTab] = useState('');
  const [pathStack, setPathStack] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const [sortKey, setSortKey] = useState('name');

  const { callbacks, loadingSelectImage, selectedProperty, chiliSelectedFrame } = useContext(ArtworkContext);
  const { handleSelectFile, handleRemoveFile } = callbacks;

  const { currentFiles, loadingFiles, hasMore, fetchMoreFiles } = useArtworkFilesData({
    activeTab,
    selectedFolder,
    sortKey,
    sortDirection,
    selectedProperty,
  });

  const tabs = [
    {
      label: 'Property',
      value: 'property',
    },
    {
      label: 'Files',
      value: 'files',
    },
  ];

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (key) => {
    setAnchorEl(null);
    setSortKey(key);
  };

  const toggleActiveTab = (key) => {
    if (activeTab !== key && selectedFolder) {
      setSelectedFolder(null);
    }
    setActiveTab(key);
  };

  const handleSelectFolder = (folder) => {
    setPathStack([...pathStack, selectedFolder]);
    setSelectedFolder(folder);
  };

  const handleSelectBack = () => {
    if (pathStack.length > 0) {
      const newPath = [...pathStack];
      const currentFolder = newPath.pop();
      setSelectedFolder(currentFolder);
      setPathStack(newPath);
    }
  };

  //Hide Search for now
  // useEffect(() => {
  //   if (!searchInput) {
  //     setSearchValue('');
  //     setShowSearchResults(false);
  //     setSelectedFolder(null);
  //     setPathStack([]);
  //     return;
  //   }

  //   const delayDebounce = setTimeout(() => {
  //     setSearchValue(searchInput);
  //     if (searchInput) {
  //       setSelectedFolder(null);
  //       setPathStack([]);
  //     }
  //   }, 500);

  //   return () => clearTimeout(delayDebounce);
  // }, [searchInput]);

  useEffect(() => {
    if (selectedProperty) {
      setActiveTab('property');
    } else setActiveTab('files');
  }, []);

  return (
    <DrawerContent>
      <DrawerContent.Header
        title="Select Image"
        loading={loadingFiles || loadingSelectImage}
      />
      <DrawerContent.Wrapper>
        <Stack spacing={1}>
          {/* <TextField
            fullWidth
            placeholder="Search"
            size="small"
            variant="outlined"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            InputProps={{
              endAdornment: searchLoading ? (
                <InputAdornment position="end">
                  <CircularProgress size={18} />
                </InputAdornment>
              ) : (
                <InputAdornment position="end">
                  <CancelOutlinedIcon
                    style={{ fontSize: 20, cursor: 'pointer' }}
                    onClick={() => setSearchInput('')}
                  />
                </InputAdornment>
              ),
            }}
          /> */}
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              {selectedProperty?.id ? (
                <Tabs
                  value={activeTab}
                  onChange={(e, value) => toggleActiveTab(value)}
                >
                  {tabs.map((tab) => (
                    <Tab
                      key={tab.value}
                      label={tab.label}
                      value={tab.value}
                    />
                  ))}
                </Tabs>
              ) : (
                <Tabs
                  value={activeTab}
                  onChange={(e, value) => toggleActiveTab(value)}
                >
                  <Tab
                    label="Files"
                    value="files"
                  />
                </Tabs>
              )}
            </Box>
          </Box>
        </Stack>
        <DrawerContent.Content>
          <InfiniteScrollPagination
            fetchData={fetchMoreFiles}
            isFetching={loadingFiles}
            hasMore={hasMore}
            loading={loadingFiles}
            heightPercent={86}
          >
            <Stack
              direction="row"
              sx={{ alignItems: 'center', justifyContent: selectedFolder ? 'space-between' : 'flex-end' }}
            >
              {selectedFolder && (
                <Stack
                  direction="row"
                  spacing={0.3}
                  sx={{ alignItems: 'center' }}
                >
                  <IconButton
                    onClick={() => handleSelectBack()}
                    sx={{
                      padding: 0.5,
                      margin: 0.5,
                    }}
                  >
                    <NavigateBeforeOutlinedIcon style={{ fontSize: 20 }} />
                  </IconButton>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: '400',
                      width: '163px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      color: '#3d3b3c',
                      textAlign: 'left',
                    }}
                  >
                    {selectedFolder.name}
                  </Typography>
                </Stack>
              )}
              <Stack
                direction="row"
                spacing={0.5}
              >
                <IconButton
                  onClick={() => setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')}
                  disabled={loadingFiles}
                  sx={{
                    padding: 0.5,
                    margin: 0.5,
                  }}
                >
                  {sortDirection === 'asc' ? (
                    <ArrowUpwardOutlinedIcon style={{ fontSize: 16 }} />
                  ) : (
                    <ArrowDownwardOutlinedIcon style={{ fontSize: 16 }} />
                  )}
                </IconButton>
                <Button
                  size="small"
                  onClick={handleClick}
                  disabled={loadingFiles}
                  sx={{ minWidth: 0, padding: 0, whiteSpace: 'nowrap' }}
                >
                  {sortKey === 'last_modified' ? 'Last Modified' : 'Name'}
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => handleClose(sortKey)}
                >
                  <MenuItem onClick={() => handleClose('last_modified')}>Last Modified</MenuItem>
                  <MenuItem onClick={() => handleClose('name')}>Name</MenuItem>
                </Menu>
              </Stack>
            </Stack>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 0,
              }}
            >
              {currentFiles?.length === 0 && !loadingFiles ? (
                <Typography
                  variant="body2"
                  sx={{ paddingTop: 2.5, textAlign: 'center' }}
                >
                  No files found in the selected {selectedFolder ? 'folder' : 'property'}
                </Typography>
              ) : (
                <FileSelectorGrid
                  items={currentFiles}
                  selectedFile={selectedFile}
                  callbacks={{
                    toggleSelectedFile: (file) => {
                      setSelectedFile(file);
                      handleSelectFile(file);
                    },
                    toggleSelectedFolder: (folder) => handleSelectFolder(folder),
                  }}
                />
              )}
            </Box>
          </InfiniteScrollPagination>
        </DrawerContent.Content>
        <DrawerContent.ActionButtons
          {...(chiliSelectedFrame?.hasContent === 'true' && chiliSelectedFrame?.type === 'image'
            ? {
                stackDirection: 'column-reverse',
                submitButtonText: 'Remove Image',
                submit: () => handleRemoveFile(),
              }
            : {
                hideSubmit: true,
              })}
          close={close}
        />
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};

export default ArtworkFiles;
